import React from 'react';
import cx from 'classnames';

const SIZES = { sm: 'size-5', md: 'size-8', lg: 'size-12' };

function Loader({ size = 'md' }: { size?: keyof typeof SIZES }) {
  return (
    <svg
      role="status"
      aria-label={gettext('Loading')}
      className={cx('animate-spin text-retino-darkviolet', SIZES[size])}
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle cx="12" cy="12" r="9" className="stroke-retino-lightviolet/40" strokeWidth="3.5" />
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeDasharray="42 14.5"
      />
    </svg>
  );
}

export default Loader;
